// src/components/QuickLinks/QuickLinks.js
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { LinkIcon } from '@heroicons/react/24/outline';

const QuickLinks = () => {
  const [showLinks, setShowLinks] = useState(false);

  const links = {
    'Official Documentation': [
      {
        title: 'Essential Eight',
        url: 'https://www.cyber.gov.au/resources-business-and-government/essential-cyber-security/essential-eight',
        description: 'Official Essential Eight documentation'
      }
    ],
    'Guidelines': [
      {
        title: 'E8 Assessment Process Guide',
        url: 'https://www.cyber.gov.au/resources-business-and-government/essential-cyber-security/essential-eight/essential-eight-assessment-process-guide',
        description: 'How to assess Essential Eight controls'
      },
      {
        title: 'ASD Blueprint for Secure Cloud',
        url: 'https://blueprint.asd.gov.au/security-and-governance/essential-eight/',
        description: 'Provides a comprehensive guide to implementing the Essential Eight controls in a cloud environment'
      }   
    ],
    'Additional Resources': [
      {
        title: 'ISM Controls',
        url: 'https://www.cyber.gov.au/resources-business-and-government/essential-cyber-security/ism',
        description: 'Information Security Manual Controls'
      },
      {
        title: 'Microsoft E8 Overview',
        url: 'https://learn.microsoft.com/en-us/compliance/anz/e8-overview',
        description: 'Microsoft E8 Overview'
      }
    ]
  };

  const portalContent = showLinks && (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-25 z-[9999]"
        onClick={() => setShowLinks(false)}
      />
      
      {/* Quick Links Panel */}
      <div 
        className="fixed top-20 right-4 w-80 bg-white rounded-lg shadow-xl border border-gray-200 p-4 z-[10000]"
      >
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-lg font-semibold">Quick Links</h3>
          <button 
            onClick={() => setShowLinks(false)}
            className="text-gray-400 hover:text-gray-600 text-xl"
          >
            ×
          </button>
        </div>
        <div className="space-y-6">
          {Object.entries(links).map(([category, categoryLinks]) => (
            <div key={category} className="space-y-2">
              <h4 className="text-sm font-medium text-gray-500">{category}</h4>
              <div className="space-y-2">
                {categoryLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block p-3 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                  >
                    <div className="text-blue-600 font-medium mb-1">{link.title}</div>
                    <p className="text-sm text-gray-600">{link.description}</p>
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );

  return (
    <div className="relative inline-block">
      <button
        onClick={() => setShowLinks(!showLinks)}
        className="p-2 text-gray-600 hover:text-blue-600 rounded-full hover:bg-blue-50 transition-colors duration-200"
        title="Quick Links"
      >
        <LinkIcon className="h-6 w-6" />
      </button>

      {portalContent && createPortal(
        portalContent,
        document.getElementById('portal-root')
      )}
    </div>
  );
};

export default QuickLinks;